// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ehJXT","title":"styles_title__YX8Oq","subtitle":"styles_subtitle__cl5Bl"};
module.exports.__checksum = "2352d8f5b892"